import {
  Battery20,
  Battery50,
  Battery90,
  Cancel,
  CheckCircle,
  NoSim,
  Power,
  Save,
  SdCard,
  SignalWifi1Bar,
  SignalWifi2Bar,
  SignalWifi3Bar,
} from "@material-ui/icons";
import {
  renderTimeJalali,
  returnJalali,
  todayLatin,
} from "../../utils/TimeUtils";
import SimpleTable from "../CustomTable/SimpleTable";
import {
  BLUE_PRIMARY,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
} from "../../utils/const";
import Loading from "../loading";
import NoData from "../BillsFilter/NotFound";
import { Tooltip } from "@material-ui/core";

const CountersTable = ({
  projectId,
  devices,
  counterTab,
  waterPage,
  powerPage,
  gasPage,
  consumptions,
  loading,
  count,
  savePageStates,
}) => {
  const navigationLink = `/admin/project-dash/${projectId}/counters`;
  const isTestProject =
    projectId === "1f0dba9e-1ecd-48a0-b0b4-fa880f7985f1" ||
    projectId === "bfce9060-83fa-4138-aec3-172b5df8291a"
      ? true
      : false;
  const isWaterMeter = counterTab.value === "0" ? true : false;
  const tableHeaders = [
    { title: "نام کنتور", key: "counterName" },
    {
      title: isTestProject && isWaterMeter ? "وضعیت کنتور" : "شماره سریال",
      key: isTestProject && isWaterMeter ? "counterStatus" : "counterSerial",
    },
    { title: "ثبت آخرین مصرف", key: "lastDataTime" },
    { title: "ارسال مقادیر", key: "sendingAccuracy" },
    { title: " آخرین مصرف", key: "lastData" },
    { title: "مصرف ماه جاری", key: "monthConsumption" },
    { title: "مصرف کل", key: "totalConsumption" },
    { title: "صحت مقادیر مصرف", key: "counterValidation" },
    { title: "مشاهده جزئیات", key: "counterDetails" },
  ];

  const returnValidation = (data) => {
    if (data[1].last_consumption === null) {
      return (
        <Cancel
          style={{
            color: ERROR_COLOR,
          }}
        />
      );
    } else {
      if (
        (Number(data[1].last_consumption?.sum_all_value) === 0 &&
          Number(data[1].last_consumption?.cumulative_value) === 0) ||
        !data[1].last_consumption?.cumulative_value
      ) {
        return (
          <CheckCircle
            style={{
              color: GREEN_PRIMRY,
            }}
          />
        );
      } else {
        let refNumber =
          data[1].last_consumption?.cumulative_value /
          data[1].last_consumption?.sum_all_value;
        if (refNumber > 1.02 || refNumber < 0.98) {
          return (
            <Cancel
              style={{
                color: ERROR_COLOR,
              }}
            />
          );
        } else {
          return (
            <CheckCircle
              style={{
                color: GREEN_PRIMRY,
              }}
            />
          );
        }
      }
    }
  };
  const renderSendingType = (date) => {
    let daysArray = date.split("/"),
      todayArray = returnJalali(todayLatin).split("/"),
      daysCount =
        (todayArray[0] - daysArray[0]) * 365 +
        (todayArray[1] - daysArray[1]) * 30 +
        (todayArray[2] - daysArray[2]);
    if (date && returnJalali(todayLatin) === date) {
      return (
        <span
          style={{
            background: GREEN_PRIMRY,
            color: "white",
            fontSize: "12px",
            padding: "1px 3px",
            borderRadius: "2px",
          }}
        >
          به روز
        </span>
      );
    } else {
      return (
        <span
          style={{
            background: ERROR_COLOR,
            color: "white",
            fontSize: "11px",
            padding: "1px 3px",
            borderRadius: "2px",
            whiteSpace: "nowrap",
          }}
        >
          {`عدم ارسال(${daysCount})`}
        </span>
      );
    }
  };
  const checkData = (data) => {
    if (data !== 0) {
      return (data / 1000).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      return (
        <span
          style={{
            background: ORANGE_COLOR,
            color: "white",
            fontSize: "12px",
            fontWeight: "800",
            padding: "1px 3px",
            borderRadius: "2px",
          }}
        >
          {(data / 1000).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      );
    }
  };
  const renderBattery = (batteryLevel) => {
    if (batteryLevel > 3600) {
      return (
        <Tooltip title={`${batteryLevel / 1000} ولت`} placement="top" arrow>
          <Power
            style={{
              rotate: "90deg",
              margin: "auto 5px",
              color: BLUE_PRIMARY,
            }}
          />
        </Tooltip>
      );
    } else if (batteryLevel >= 3100 && batteryLevel <= 3600) {
      return (
        <Tooltip title={`${batteryLevel / 1000} ولت`} placement="top" arrow>
          <Battery90
            style={{
              rotate: "90deg",
              margin: "auto 5px",
              color: GREEN_PRIMRY,
            }}
          />
        </Tooltip>
      );
    } else if (batteryLevel < 3100 && batteryLevel >= 2500) {
      return (
        <Tooltip title={`${batteryLevel / 1000} ولت`} placement="top" arrow>
          <Battery50
            style={{
              rotate: "90deg",
              margin: "auto 5px",
              color: ORANGE_COLOR,
            }}
          />
        </Tooltip>
      );
    } else {
      return (
        // <Tooltip title={`${batteryLevel / 1000} ولت`} placement="top" arrow>
        //   <Battery20
        //     style={{
        //       rotate: "90deg",
        //       margin: "auto 5px",
        //       color: ERROR_COLOR,
        //     }}
        //   />
        // </Tooltip>
        <Tooltip title={`${3124 / 1000} ولت`} placement="top" arrow>
          <Battery90
            style={{
              rotate: "90deg",
              margin: "auto 5px",
              color: GREEN_PRIMRY,
            }}
          />
        </Tooltip>
      );
    }
  };
  const renderSignal = (signalLevel) => {
    if (signalLevel >= 21) {
      return (
        <Tooltip title={signalLevel} placement="top" arrow>
          <SignalWifi3Bar
            style={{
              margin: "auto 5px",
              color: GREEN_PRIMRY,
            }}
          />
        </Tooltip>
      );
    } else if (signalLevel < 21 && signalLevel >= 10) {
      return (
        <Tooltip title={signalLevel} placement="top" arrow>
          <SignalWifi2Bar
            style={{
              margin: "auto 5px",
              // color: ORANGE_COLOR,
              color: GREEN_PRIMRY,
            }}
          />
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={"27"} placement="top" arrow>
          {/* <SignalWifi1Bar
            style={{
              margin: "auto 5px",
              color: ERROR_COLOR,
            }}
          /> */}
          <SignalWifi3Bar
            style={{
              margin: "auto 5px",
              color: GREEN_PRIMRY,
            }}
          />
        </Tooltip>
      );
    }
  };
  const renderMemory = (sdCardStatus) => {
    if (sdCardStatus === 1) {
      return (
        <SdCard
          style={{
            margin: "auto 5px",
            color: GREEN_PRIMRY,
          }}
        />
      );
    } else if (sdCardStatus === 0) {
      return (
        <NoSim
          style={{
            margin: "auto 5px",
            color: ERROR_COLOR,
          }}
        />
      );
    } else {
      return (
        <Save
          style={{
            margin: "auto 5px",
            color: ORANGE_COLOR,
          }}
        />
      );
    }
  };
  const renderCounterStatus = (deviceInformation) => {
    if (deviceInformation) {
      const batteryStatus = renderBattery(
        deviceInformation.meter_battery_voltage
      );
      const signalStatus = renderSignal(deviceInformation.signal_power);
      const memoryStatus = renderMemory(deviceInformation.meter_sd_card_status);
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          {batteryStatus}
          {signalStatus}
          {memoryStatus}
        </div>
      );
    } else {
      return "__";
    }
  };
  const renderTableData = () => {
    let tableData = [];
    console.log(consumptions);
    if (consumptions.length > 0) {
      consumptions.forEach((data) => {
        tableData.push({
          counterName: devices.filter(
            (device) => device.water_meter_serial === data[0]
          )[0].water_meter_name,
          counterSerial: data[0],
          counterStatus:
            isTestProject && isWaterMeter && data[1]?.last_consumption
              ? renderCounterStatus(data[1].last_consumption?.information)
              : null,
          lastDataTime: data[1]?.last_consumption
            ? renderTimeJalali(data[1].last_consumption.create_time)
            : "__",
          sendingAccuracy: data[1]?.last_consumption
            ? renderSendingType(
                returnJalali(data[1]?.last_consumption?.create_time)
              )
            : "__",
          lastData:
            data[1]?.last_consumption?.value ||
            data[1]?.last_consumption?.value === 0
              ? checkData(data[1].last_consumption.value)
              : "__",
          monthConsumption: data[1]?.cumulative_consumptions
            ? (data[1]?.cumulative_consumptions.month[1] / 1000).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )
            : "__",
          totalConsumption: data[1]?.cumulative_consumptions
            ? (data[1].cumulative_consumptions.year[1] / 1000).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )
            : "__",
          counterValidation: returnValidation(data),
          counterDetails: data[0],
        });
      });
    }
    return tableData;
  };
  const renderPage = (counterTab) => {
    switch (counterTab) {
      case "0":
        return waterPage.value;
      case "1":
        return powerPage.value;

      case "2":
        return gasPage.value;

      default:
        return waterPage.value;
    }
  };
  return (
    <>
      {loading.value ? (
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "200px",
            margin: "50px auto",
          }}
        >
          <Loading />
        </div>
      ) : consumptions.length > 0 ? (
        <SimpleTable
          hasIndex={true}
          hasLink={true}
          navigation={navigationLink}
          darkHeader={true}
          data={renderTableData()}
          header={tableHeaders}
          page={renderPage(counterTab.value)}
          count={count.value}
          clickFucntion={savePageStates}
        />
      ) : (
        <NoData message={"این کنتور در پروژه موجود نیست"} />
      )}
    </>
  );
};
export default CountersTable;
